import { Avatar, Spin, Typography, Tooltip, Tabs, Col, Row } from 'antd'
import { LoadingIcon, RightArrowIcon } from 'components/Icons'
import _ from 'lodash'
import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useReducer, useRef, useState } from 'react'
import UserAPI from 'restAPI/UserAPI'
import { CellRenderers } from 'utils/tableUtils'
import { getUrlSearch } from "utils/urlUtil";
import { FINDING_STATUS_DISPLAY_TEXT, FINDING_ACTIONS, FINDING_STATUS_PROPOSED_DISPLAY_TEXT, ATTACHMENT_LINK_PREFIX } from './Constants'
import MessageEditor from 'components/MessageEditor';
import { MarkdownFormatter } from "components/MarkupFormatter";
import Vocabulary, { getVocabulary } from 'components/Vocabulary'
import { transformComment } from 'utils/commentUtil'
import CommentComponent from 'components/CommentComponent'
import moment from 'moment';
import { BASE_GUTTER } from 'constants/Layout';
import parseHtml from 'utils/parserUtil'
import EnvironmentName from 'views/GlobalSettings/EnvironmentName'
import ACSeverityTag from 'ac-components/ACSeverityTag'
import { UNASSIGNED } from './ChangeOwner'
import { RuleStatusLabels } from "constants/ReportConstants";
const { Text } = Typography;
export const initialState = {
    loading: true,
    users: [],
    events: [],
    comments: [],
    history: [],
}


export const Actions = {
    LOADING: "loading",
    LOADED: "loaded",
    USERS_LOADED: "users_loaded",
}

export const EVENTS_MAP = {
    TICKET_CREATED: 'TICKET_CREATED',
    TICKET_STATUS_UPDATED: 'TICKET_STATUS_UPDATED',
    TICKET_SEVERITY_UPDATED: 'TICKET_SEVERITY_UPDATED',
    STATUS_UPDATE: 'STATUS_UPDATE',
    SEVERITY_UPDATE: 'SEVERITY_UPDATE',
    CATEGORY_UPDATE: 'CATEGORY_UPDATE',
    ASSIGNED_OWNER: 'ASSIGNED_OWNER',
    PRODUCT_UPDATE: 'PRODUCT_UPDATE',
    MITIGATION_UPDATED: 'MITIGATION_UPDATED',
    STEP_TO_REPRODUCE_UPDATE: 'STEP_TO_REPRODUCE_UPDATE',
    DUE_DATE_UPDATE: 'DUE_DATE_UPDATE',
    PROPOSE_DUE_DATE: FINDING_ACTIONS.PROPOSE_DUE_DATE,
    PROPOSE_ASSIGNEE: FINDING_ACTIONS.PROPOSE_ASSIGNEE,
    PROPOSE_CATEGORY: FINDING_ACTIONS.PROPOSE_CATEGORY,
    PROPOSE_SEVERITY: FINDING_ACTIONS.PROPOSE_SEVERITY,
    PROPOSE_FALSE_POSITIVE: FINDING_ACTIONS.PROPOSE_FALSE_POSITIVE,
    PROPOSE_MITIGATED: FINDING_ACTIONS.PROPOSE_MITIGATED,
    PROPOSE_ACCEPTRISK: FINDING_ACTIONS.PROPOSE_ACCEPTRISK,
    PROPOSE_BASIC_CHANGE: FINDING_ACTIONS.PROPOSE_BASIC_CHANGE,
    PROPOSE_SUPPRESSED: FINDING_ACTIONS.PROPOSE_SUPPRESSED,
    PROPOSE_CONTROLLED: FINDING_ACTIONS.PROPOSE_CONTROLLED,
    PROPOSE_IN_PROGRESS: FINDING_ACTIONS.PROPOSE_IN_PROGRESS,
    PROPOSE_TRIAGE: FINDING_ACTIONS.PROPOSE_TRIAGE,
    PROPOSE_CUSTOM_FIELDS: FINDING_ACTIONS.PROPOSE_CUSTOM_FIELDS,
    TAKE_ACTION_ON_PROPOSED_CUSTOM_FIELDS: FINDING_ACTIONS.TAKE_ACTION_ON_PROPOSED_CUSTOM_FIELDS,
    TAKE_ACTION_ON_PROPOSED_ACCEPT_RISK: FINDING_ACTIONS.TAKE_ACTION_ON_PROPOSED_ACCEPT_RISK,
    TAKE_ACTION_ON_PROPOSED_FALSE_POSITIVE: FINDING_ACTIONS.TAKE_ACTION_ON_PROPOSED_FALSE_POSITIVE,
    TAKE_ACTION_ON_PROPOSED_OPEN: FINDING_ACTIONS.TAKE_ACTION_ON_PROPOSED_OPEN,
    TAKE_ACTION_ON_PROPOSED_CONFIRMED: FINDING_ACTIONS.TAKE_ACTION_ON_PROPOSED_CONFIRMED,
    TAKE_ACTION_ON_PROPOSED_DUE_DATE: FINDING_ACTIONS.TAKE_ACTION_ON_PROPOSED_DUE_DATE,
    TAKE_ACTION_ON_PROPOSED_ASSIGN_OWNER: FINDING_ACTIONS.TAKE_ACTION_ON_PROPOSED_ASSIGN_OWNER,
    TAKE_ACTION_ON_PROPOSED_MITIGATION: FINDING_ACTIONS.TAKE_ACTION_ON_PROPOSED_MITIGATION,
    TAKE_ACTION_ON_PROPOSED_SEVERITY: FINDING_ACTIONS.TAKE_ACTION_ON_PROPOSED_SEVERITY,
    TAKE_ACTION_ON_PROPOSED_CATEGORY: FINDING_ACTIONS.TAKE_ACTION_ON_PROPOSED_CATEGORY,
    TAKE_ACTION_ON_PROPOSED_BASIC_CHANGE: FINDING_ACTIONS.TAKE_ACTION_ON_PROPOSED_BASIC_CHANGE,
    TAKE_ACTION_ON_PROPOSED_SUPPRESSED: FINDING_ACTIONS.TAKE_ACTION_ON_PROPOSED_SUPPRESSED,
    TAKE_ACTION_ON_PROPOSED_CONTROLLED: FINDING_ACTIONS.TAKE_ACTION_ON_PROPOSED_CONTROLLED,
    TAKE_ACTION_ON_PROPOSED_TRIAGE: FINDING_ACTIONS.TAKE_ACTION_ON_PROPOSED_TRIAGE,
    TAKE_ACTION_ON_PROPOSED_INPROGRESS: FINDING_ACTIONS.TAKE_ACTION_ON_PROPOSED_IN_PROGRESS,
    TICKET_DETACHED: 'TICKET_DETACHED',
    TAGS_UPDATED: 'TAGS_UPDATED',
    DESCRIPTION_UPDATED: 'DESCRIPTION_UPDATED',
    IMPACT_UPDATED: 'IMPACT_UPDATED',
    TOOL_FINDING_ID_UPDATED: 'TOOL_FINDING_ID_UPDATED',
    AMC_RULES_UPDATED: 'AMC_RULES_UPDATED',
    CVES_UPDATED: 'CVES_UPDATED',
    CWES_UPDATED: 'CWES_UPDATED',
    VENDOR_UPDATE: 'VENDOR_UPDATE',
    TOOL_FINDING_CATEGORY_UPDATED: 'TOOL_FINDING_CATEGORY_UPDATED',
    CVSS_VECTOR_UPDATED: 'CVSS_VECTOR_UPDATED',
    CVSS_SCORE_UPDATED: 'CVSS_SCORE_UPDATED',
    TOOL_SEVERITY_UPDATE: 'TOOL_SEVERITY_UPDATE',
    TOOL_STATUS_UPDATE: 'TOOL_STATUS_UPDATE',
    TOOL_CATEGORY_UPDATE: 'TOOL_CATEGORY_UPDATE',
    BUSINESS_UNIT_UPDATE: 'BUSINESS_UNIT_UPDATE',
    PROJECT_UPDATE: 'PROJECT_UPDATE',
    TITLE_UPDATE: 'TITLE_UPDATE',
    UPDATE_SCAN_TYPE: 'UPDATE_SCAN_TYPE',
    ACTION_TAKEN: 'ACTION_TAKEN',
    COMPONENT_VERSION_UPDATE: 'COMPONENT_VERSION_UPDATE',
    COMPONENT_NAME_UPDATE: 'COMPONENT_NAME_UPDATE',
    COMPONENT_FIX_VERSIONS_UPDATE: 'COMPONENT_FIX_VERSIONS_UPDATE',
    UPDATE_FINDING_URL_ENDPOINT: 'UPDATE_FINDING_URL_ENDPOINT',
    FOUND_ON_DATE_UPDATE: 'FOUND_ON_DATE_UPDATE',
    OTHER_PROPERTIES: 'OTHER_PROPERTIES',
    CVE_BASE_SCORE_UPDATE: 'CVE_BASE_SCORE_UPDATE',
    EXPLOITED_UPDATE: 'EXPLOITED_UPDATE',
    ATTACHMENT_UPDATED: 'ATTACHMENT_UPDATED',
    TRIAGE_INFO_UPDATE: 'TRIAGE_INFO_UPDATE',
    ADD_CORRELATED_FINDING: "ADD_CORRELATED_FINDING",
    DELETE_CORRELATED_FINDING: "DELETE_CORRELATED_FINDING",
    RISK_REGISTER_UPDATE: "RISK_REGISTER_UPDATE",
    ENVIRONMENT_UPDATE: "ENVIRONMENT_UPDATE",
    FINDING_CREATED: "FINDING_CREATED",
    UPDATE_CUSTOM_FIELDS: "UPDATE_CUSTOM_FIELDS",
    ASSESSMENT_TAGS_UPDATED: "ASSESSMENT_TAGS_UPDATED",
    ASSESSMENT_UPDATE: "ASSESSMENT_UPDATE",
    CVSS_GROUP_MODIFIER_APPLIED:  "CVSS_GROUP_MODIFIER_APPLIED",
    CVSS_SUBGROUP_MODIFIER_APPLIED: "CVSS_SUBGROUP_MODIFIER_APPLIED",
    CVSS_FINDING_MODIFIER_APPLIED: "CVSS_FINDING_MODIFIER_APPLIED",
    CVSS_MODIFIER_REMOVED: "CVSS_MODIFIER_REMOVED",
    CVSS_CVE_BASE_VECTOR_UPDATED: "CVSS_CVE_BASE_VECTOR_UPDATED",
    SLA_RECALCULATION: "SLA_RECALCULATION",
    SLA_RECOVERY: "SLA_RECOVERY"
};

export function reducer(state, action){
    switch (action.type){
        case Actions.LOADING:
            return {
                ...state, 
                loading: true
            };
        case Actions.LOADED:
            { const comments = [], history = [];
            (action.payload || []).sort((a, b) => a.createdAt - b.createdAt).forEach(object => {
                if(isComment(object)){
                    comments.push(object);
                } else {
                    history.push(object);
                }
            })
            return {
                ...state,
                loading: false,
                events: action.payload,
                comments,
                history
            } }
        case Actions.USERS_LOADED:
            return {
                ...state,
                users: action.payload,
                newUser: action.payload.map(user => {
                     return {
                         id: user.userId,
                         displayName:  user.name,
                         email: user.email
                     }
                })
            }
        default: 
            return state;
    }
}


function FindingHistory({id, getContents, postComment, title = "Team Collaboration", inputClassName = "", historyScrollable, newView , snapshotId, canScroll = true}, ref ) {

    const thisRef = useRef();
    const [state, dispatch] = useReducer(reducer, initialState);
    const [activeTab, setActiveTab] = useState("collaboration");
    const { loading, users, comments, history, events, newUser } = state;

    const fetchEvents = useCallback((cb = _.noop) => {
        if(!id){
            return;
        }
        dispatch({ type: Actions.LOADING });

        const { promise, cancel } = getContents(id);
        promise.then(
            ({content}) => dispatch({type: Actions.LOADED, payload: content}),
            e => console.log(e)
        ).then(cb);

        return cancel;
    },[getContents, id]);

    useImperativeHandle(ref,() => ({
        refresh: fetchEvents
    }));

    useEffect(() => {
        const {promise, cancel} = UserAPI.getAll();
        promise.then(
            (data) => {
                const modifiedData = data.map(user => ({ ...user, userId: user.id, name: user.displayName }));
                dispatch({type: Actions.USERS_LOADED, payload: modifiedData});
            },
            e => console.error(e)
        );
        return cancel;
    }, []);

    useEffect(fetchEvents, [id, fetchEvents])

    const onSend = async ({ htmlText: comment, mentionUserIds: userIds }) => {
        if (comment) {
            await postComment(id, comment, userIds);
        }
        fetchEvents(() => {
            try {
                thisRef.current.children[thisRef.current.children.length - 1].scrollIntoView();
            } catch (e) {
                console.error(e);
            }
        });
    }
    if(newView){
        return (
            <>
                <div className="p-sm">
                    <Tabs destroyInactiveTabPane size="small" defaultActiveKey="collaboration" animated={false} onChange={setActiveTab}>
                        <Tabs.TabPane tab={title} key="collaboration">
                            <Spin spinning={loading} indicator={<LoadingIcon />}>
                                <EventList ref={thisRef} list={comments} users={users} historyScrollable={historyScrollable} newUser={newUser} />   
                            </Spin>
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="History" key="history">
                            <Spin spinning={loading} indicator={<LoadingIcon />}>
                                <EventList list={history} users={users} newUser={newUser} activeTab={activeTab} onSend={onSend}/>
                            </Spin>
                        </Tabs.TabPane>
                    </Tabs>
                </div>
                {activeTab === "collaboration" && <MessageEditor disableEditor={snapshotId} onSubmit={onSend} className={`${inputClassName} p-sm ${snapshotId ? "disabled" : ''}`} users={newUser} hideEmoji={true} hideOldUpload />}
            </>
        )
    }
    return (
        <>
            <Spin spinning={loading} indicator={<LoadingIcon />}>
                <div className="p-sm" ref={ref}  >
                    <div className="text-bold">{title}</div>
                    {
                        _.isEmpty(events)
                        ?
                        <div className="text-center p-l">No actions performed!</div>
                        :
                        <div style={{maxHeight: historyScrollable ? 250 : undefined, overflow:(canScroll ? "scroll" : '') }}>
                            <CommentComponent
                                commentList={events}
                                onCommentSubmit={onSend}
                                getItemDataProps={item => getItemDataProps({event: item, users, newUser})}
                            />
                        </div>
                    }
                </div>
            </Spin>
            <MessageEditor onSubmit={onSend} disableEditor={snapshotId} className={`${inputClassName} p-sm ${snapshotId ? "disabled" : ''}`} users={newUser} hideEmoji={true} hideOldUpload />
        </>
    )
}

export default forwardRef(FindingHistory);

const EventList = forwardRef(({ list = [], users, historyScrollable, newUser=[], activeTab, onSend }, ref) => {
    if(_.isEmpty(list)){
        return <div className="text-center p-l">No comments/events</div>;
    }
    const customProps = {};
    if (activeTab === "collaboration") {
        customProps.onCommentSubmit = onSend;
        customProps.showEditButton = true;
    }
    return (
        <div style={{maxHeight: historyScrollable ? 250 : undefined, overflow: "scroll"}} ref={ref}>
            <CommentComponent
                commentList={list}
                {...customProps}
                getItemDataProps={item => getItemDataProps({event: item, users, newUser})}
            />
        </div>
    )
})


function getItemDataProps({ event = {}, users = [], newUser = [] }) {
    const user = _.find(users, { email: event.createdBy}) || {};
    const userName = user.name || event.createdBy || "";
    const matches = userName.match(/\b(\w)/g);

    let content = parseHtml(event.note, {
        transform: (reactNode, node, index) =>  transformComment(reactNode, node, index, newUser)
    });
    if(isHistory(event)){
        content = (
            <>
                <RenderChangeText event={event} />
                <br />
                <Text strong>Note:</Text> {content ? parseHtml(content) : CellRenderers.VALUE_OR_NA()}
            </>
        )
    }
    return {
        author: userName,
        avatar: <Avatar size="small">{matches?.join("") || userName[0]}</Avatar>,
        content: !_.isArray(content) && !_.isEmpty(content) && typeof content === 'string' ? <MarkdownFormatter markdown={content || ""} collapsible={true} /> : <>{content}</>,
        datetime: (
            <Tooltip title={CellRenderers.TIME_RELATIVE(event.createdAt)} placement="right">
                {CellRenderers.TIME(event.createdAt)}
            </Tooltip>
        )
    }
}

export function RenderChangeText({event}){

    const { eventOldData = CellRenderers.VALUE_OR_NA(), eventNewData = CellRenderers.VALUE_OR_NA() } = event;
    if(event.event === EVENTS_MAP.CATEGORY_UPDATE){
        return <>Changed <Vocabulary name="category" /> from {eventOldData} to {eventNewData}</>;
    }
    if(event.event === EVENTS_MAP.SEVERITY_UPDATE){
        return <span className='d-flex align-items-center'>Changed <Vocabulary name="severity" /> from {<ACSeverityTag value={eventOldData} className={"m-l-xs m-r-xs"} />} to {<ACSeverityTag value={eventNewData} className={"m-l-xs"} />}</span>;
    }
    if(event.event === EVENTS_MAP.TOOL_SEVERITY_UPDATE){
        return <span className='d-flex align-items-center'>Changed tool <Vocabulary name="severity" /> from {<ACSeverityTag value={eventOldData} isCustomizedValue={false} className={"m-l-xs m-r-xs"} />} to {<ACSeverityTag value={eventNewData} isCustomizedValue={false} className={"m-l-xs"} />}</span>;
    }
    if(event.event === EVENTS_MAP.MITIGATION_UPDATED){
        return <RenderCompareColumns title="Mitigation updated" oldData={eventOldData} newData={eventNewData} editorContent />
    }
    if (event.event === EVENTS_MAP.STEP_TO_REPRODUCE_UPDATE){
        return <RenderCompareColumns title="Steps To Reproduce updated" oldData={eventOldData} newData={eventNewData} editorContent />
    }
    if(event.event === EVENTS_MAP.DESCRIPTION_UPDATED){
        return <RenderCompareColumns title="Description updated" oldData={eventOldData} newData={eventNewData} editorContent />
    }
    if(event.event === EVENTS_MAP.IMPACT_UPDATED){
        return <RenderCompareColumns title="Impact updated" oldData={eventOldData} newData={eventNewData} editorContent />
    }
    if(event.event === EVENTS_MAP.TOOL_FINDING_ID_UPDATED){
        return <>Changed Tool Finding ID from {CellRenderers.VALUE_OR_NA(eventOldData)} to {CellRenderers.VALUE_OR_NA(eventNewData)}</>;
    }
    if(event.event === EVENTS_MAP.CVES_UPDATED){
        return <RenderArrayStringData title="Changed CVE from" oldData={eventOldData} newData={eventNewData}/>
    }
    if(event.event === EVENTS_MAP.CWES_UPDATED){
        return <RenderArrayStringData title="Changed CWE from" oldData={eventOldData} newData={eventNewData} />
    }
    if(event.event === EVENTS_MAP.TOOL_FINDING_CATEGORY_UPDATED || event.event === EVENTS_MAP.TOOL_CATEGORY_UPDATE){
        return  <>Changed Tool <Vocabulary name="category" /> from {CellRenderers.VALUE_OR_NA(eventOldData)} to {CellRenderers.VALUE_OR_NA(eventNewData)}</>
    }
    if(event.event === EVENTS_MAP.AMC_RULES_UPDATED){
        return <RenderArrayStringData title="Changed AMC Rule from" oldData={eventOldData} newData={eventNewData}/>
    }
    if(event.event === EVENTS_MAP.STATUS_UPDATE){
        return <>Changed finding status from {FINDING_STATUS_DISPLAY_TEXT[eventOldData]} to {FINDING_STATUS_DISPLAY_TEXT[eventNewData]}</>;
    }
    if(event.event === EVENTS_MAP.TOOL_STATUS_UPDATE){
        return <>Changed tool status from {FINDING_STATUS_DISPLAY_TEXT[eventOldData]} to {FINDING_STATUS_DISPLAY_TEXT[eventNewData]}</>;
    }
    if(event.event === EVENTS_MAP.CVSS_VECTOR_UPDATED){
        return <>Changed CVSS Vector from <strong>{CellRenderers.VALUE_OR_NA(eventOldData)}</strong> to <strong>{CellRenderers.VALUE_OR_NA(eventNewData)}</strong></>;
    }
    if(event.event === EVENTS_MAP.CVSS_SCORE_UPDATED || event.event === EVENTS_MAP.CVE_BASE_SCORE_UPDATE){
        return <>Changed Base Score from {CellRenderers.VALUE_OR_NA(eventOldData)} to {CellRenderers.VALUE_OR_NA(eventNewData)}</>;
    }
    if(event.event === EVENTS_MAP.EXPLOITED_UPDATE){
        return <>Changed Exploit Available from {_.upperFirst(CellRenderers.VALUE_OR_NA(eventOldData))} to {_.upperFirst(CellRenderers.VALUE_OR_NA(eventNewData))}</>;
    }
    if(event.event === EVENTS_MAP.TICKET_CREATED) {
        return `Ticket created.`
    }
    if(event.event === EVENTS_MAP.TICKET_DETACHED) {
        return `Ticket detached.`;
    }
    if(event.event === EVENTS_MAP.ASSIGNED_OWNER) {
        return <>Changed <Vocabulary name="owner" /> from {eventOldData ?? UNASSIGNED} to {event.ownerName || eventNewData || UNASSIGNED}</>;
    }
    if(event.event === EVENTS_MAP.DUE_DATE_UPDATE) {
        return <><Vocabulary name="resolution" /> Due Date Changed from {renderDate(event.eventOldData)} to {renderDate(event.eventNewData)}</>;
    }
    if(event.event === EVENTS_MAP.TICKET_SEVERITY_UPDATED) {
        return(
            <>
                <span>Previous <Vocabulary name="severity" />: {CellRenderers.CUSTOMIZED_SEVERITY(eventOldData)}</span><br />
                <span>Current <Vocabulary name="severity" />: {CellRenderers.CUSTOMIZED_SEVERITY(eventNewData)}</span>
            </>
        );
    }
    if(event.event === EVENTS_MAP.TICKET_STATUS_UPDATED) {
        return(
            <>
                <span>Previous Ticket Status: {CellRenderers.VALUE_OR_NA(eventOldData)}</span><br />
                <span>Current Ticket Status: {CellRenderers.VALUE_OR_NA(eventNewData)}</span>
            </>
        );
    }
    if(event.event === EVENTS_MAP.TAGS_UPDATED) {
        if (_.isEmpty(eventOldData)) {
            try {
                const parseData = JSON.parse(eventNewData);
                return <RenderTagsUpdate data={parseData} />
            } catch(e) {
                console.log("Fallback to compatible format", e);
            }
        }
        return <RenderArrayStringData title="Finding tags updated from" oldData={eventOldData} newData={eventNewData}/>
    }
    if(event.event === EVENTS_MAP.PRODUCT_UPDATE) {
        return <BasicDetailsUpdate {...{eventOldData, eventNewData}} />
    }
    if(event.event === EVENTS_MAP.BUSINESS_UNIT_UPDATE) {
        return <BasicDetailsUpdate {...{eventOldData, eventNewData, showBusinessUnit: true}} />
    }
    if(event.field === 'status'){
        return `Changed status from ${event.oldValue === "SUCCEEDED" ? "Passed" : (RuleStatusLabels[event.oldValue] || _.capitalize(event.oldValue))} to ${event.value === "SUCCEEDED" ? "Passed" : (RuleStatusLabels[event.value] || _.capitalize(event.value))}`;
    }
    if(event.field === 'expiration'){
        return `Changed expiration from ${event.oldValue || 0} to ${event.value}`;
    }
    if(event.field === 'files'){
        return event.isDeleted ? `${event.value} file deleted.` : `${event.value} file uploaded.`;
    }
    if(event.event === EVENTS_MAP.PROPOSE_FALSE_POSITIVE){
        return <>Propose finding status from {FINDING_STATUS_PROPOSED_DISPLAY_TEXT[eventOldData] || eventOldData} to {FINDING_STATUS_PROPOSED_DISPLAY_TEXT[eventNewData] || eventNewData}</>;
    }
    if([EVENTS_MAP.TAKE_ACTION_ON_PROPOSED_FALSE_POSITIVE, EVENTS_MAP.TAKE_ACTION_ON_PROPOSED_MITIGATION, EVENTS_MAP.TAKE_ACTION_ON_PROPOSED_SUPPRESSED, EVENTS_MAP.ACTION_TAKEN, EVENTS_MAP.TAKE_ACTION_ON_PROPOSED_CONTROLLED, EVENTS_MAP.TAKE_ACTION_ON_PROPOSED_TRIAGE, EVENTS_MAP.TAKE_ACTION_ON_PROPOSED_INPROGRESS].indexOf(event.event) !== -1){
        return <>Proposal {event.reason} for finding status change from {FINDING_STATUS_PROPOSED_DISPLAY_TEXT[eventOldData] || eventOldData} to  {FINDING_STATUS_PROPOSED_DISPLAY_TEXT[eventNewData] || eventNewData}</>;
    }
    if(event.event === EVENTS_MAP.PROPOSE_CATEGORY){
        return <>Propose <Vocabulary name="category" /> change from {eventOldData} to {eventNewData}</>;
    }
    if(event.event === EVENTS_MAP.TAKE_ACTION_ON_PROPOSED_CATEGORY){
        return <>Proposal {event.reason} for <Vocabulary name="category" /> change from {eventOldData} to {eventNewData}</>;
    }
    if(event.event === EVENTS_MAP.PROPOSE_SEVERITY){
        return <span className='d-flex align-items-center'>Propose <Vocabulary name="severity" /> from {<ACSeverityTag value={eventOldData} className={"m-x-xs"} />}to {<ACSeverityTag value={eventNewData} className={"m-l-xs"} />}</span>;
    }
    if(event.event === EVENTS_MAP.TAKE_ACTION_ON_PROPOSED_SEVERITY){
        return <span className='d-flex align-items-center'>Proposal {event.reason} for <Vocabulary name="severity" /> change from {<ACSeverityTag value={eventOldData} className={"m-x-xs"} />}to {<ACSeverityTag value={eventNewData} className={"m-l-xs"} />}</span>;
    }
    if(event.event === EVENTS_MAP.PROPOSE_DUE_DATE) {
        return <>Propose <Vocabulary name="resolution" /> Due Date from {renderDate(event.eventOldData)} to {renderDate(event.eventNewData)}</>;
    }
    if(event.event === EVENTS_MAP.TAKE_ACTION_ON_PROPOSED_DUE_DATE) {
        return <>Proposal {event.reason} for <Vocabulary name="resolution" /> Due Date change from {renderDate(event.eventOldData)} to {renderDate(event.eventNewData)}</>;
    }
    if(event.event === EVENTS_MAP.PROPOSE_ASSIGNEE) {
        return <>Propose <Vocabulary name="owner" /> from {eventOldData ?? UNASSIGNED} to {event.ownerName || eventNewData || UNASSIGNED}</>;
    }
    if(event.event === EVENTS_MAP.TAKE_ACTION_ON_PROPOSED_ASSIGN_OWNER) {
        return <>Proposal {event.reason} for <Vocabulary name="owner" /> change from {eventOldData ?? UNASSIGNED} to {event.ownerName || eventNewData || UNASSIGNED}</>;
    }
    if([EVENTS_MAP.PROPOSE_ACCEPTRISK, EVENTS_MAP.PROPOSE_SUPPRESSED, EVENTS_MAP.PROPOSE_MITIGATED, EVENTS_MAP.PROPOSE_CONTROLLED, EVENTS_MAP.PROPOSE_TRIAGE, EVENTS_MAP.PROPOSE_IN_PROGRESS].indexOf(event.event) !== -1) {
        return <>Propose finding status from {FINDING_STATUS_PROPOSED_DISPLAY_TEXT[eventOldData] || eventOldData} to {FINDING_STATUS_PROPOSED_DISPLAY_TEXT[eventNewData] || eventNewData}</>;
    }
    if(event.event === EVENTS_MAP.TAKE_ACTION_ON_PROPOSED_ACCEPT_RISK) {
        return <>Proposal {event.reason} for finding status change from {FINDING_STATUS_PROPOSED_DISPLAY_TEXT[eventOldData] || eventOldData} to {FINDING_STATUS_PROPOSED_DISPLAY_TEXT[eventNewData] || eventNewData}</>;
    }
    if(event.event === EVENTS_MAP.PROPOSE_BASIC_CHANGE) {
        return <>Propose Basic Information from {getVocabularyDisplayText(eventOldData)} to {getVocabularyDisplayText(eventNewData)}</>;
    }
    if(event.event === EVENTS_MAP.TAKE_ACTION_ON_PROPOSED_BASIC_CHANGE) {
        return <>Proposal {event.reason} for Basic Information from {getVocabularyDisplayText(eventOldData)} to {getVocabularyDisplayText(eventNewData)}</>;
    }
    if(event.event === EVENTS_MAP.PROPOSE_CUSTOM_FIELDS) {
        const { oldData, newData } = proposeCustomFieldsHistory(eventOldData, eventNewData)
        return `Proposed custom fields ${oldData} -> ${newData}`
    }
    if(event.event === EVENTS_MAP.TAKE_ACTION_ON_PROPOSED_CUSTOM_FIELDS) {
        const { oldData } = proposeCustomFieldsHistory(eventOldData, eventNewData)
        return `Proposal ${event.reason === "Approved" ? "Accepted" : "Rejected"} for Custom field ${oldData} -> ${eventNewData}`
    }
    if(event.event === EVENTS_MAP.PROJECT_UPDATE) {
        return <>Changed <Vocabulary name="project" /> from {eventOldData} to {eventNewData}</>;
    }
    if (event.event === EVENTS_MAP.TITLE_UPDATE) {
        return <RenderCompareColumns title="Summary updated" oldData={eventOldData} newData={eventNewData} />
    }
    if(event.event === EVENTS_MAP.UPDATE_SCAN_TYPE){
        return  <>Changed Scan Type from {CellRenderers.VALUE_OR_NA(eventOldData)} to {CellRenderers.VALUE_OR_NA(eventNewData)}</>
    }
    if(event.event === EVENTS_MAP.COMPONENT_VERSION_UPDATE){
        return <>Changed Component Affected Version from {CellRenderers.VALUE_OR_NA(eventOldData)} to {CellRenderers.VALUE_OR_NA(eventNewData)}</>;
    }
    if(event.event === EVENTS_MAP.COMPONENT_NAME_UPDATE){
        return <>Changed Component Name from {CellRenderers.VALUE_OR_NA(eventOldData)} to {CellRenderers.VALUE_OR_NA(eventNewData)}</>;
    }
    if(event.event === EVENTS_MAP.COMPONENT_FIX_VERSIONS_UPDATE){
        return <>Changed Component Fix Version from {CellRenderers.VALUE_OR_NA(eventOldData)} to {CellRenderers.VALUE_OR_NA(eventNewData)}</>;
    }
    if(event.event === EVENTS_MAP.UPDATE_FINDING_URL_ENDPOINT){
        return <>Changed Endpoint from {CellRenderers.VALUE_OR_NA(eventOldData)} to {eventNewData}</>;
    }
    if(event.event === EVENTS_MAP.FOUND_ON_DATE_UPDATE){
        return <>Changed found on date from {renderDate(event.eventOldData)} to {renderDate(event.eventNewData)}</>;
    }
    if(event.event === EVENTS_MAP.ENVIRONMENT_UPDATE){
        return <>Changed environment from {eventOldData} to {eventNewData}</>;
    }
    if(event.event === EVENTS_MAP.FINDING_CREATED){
        return event.note;
    }
    if(event.event === EVENTS_MAP.OTHER_PROPERTIES) {
        
        const oldData = JSON.parse(eventOldData);
        const newData = JSON.parse(eventNewData);

        return <>Following properties updated{OtherPropertyDetailItem(oldData, newData)}</>
    }
    if(event.event === EVENTS_MAP.ATTACHMENT_UPDATED) {
        return event.note;
    }
    if(event.event === EVENTS_MAP.TRIAGE_INFO_UPDATE){
        return parseHtml(event.note);
    }
    if(event.event === EVENTS_MAP.ADD_CORRELATED_FINDING) {
        const eventIds = eventNewData.split(",");

            return <>Added correlation, ID: {_.map(eventIds, (event, index) => {
                return <React.Fragment key={event}>
                <Typography.Link href={`#/findings?${getUrlSearch({
                    filters: {
                        correlationIds: [event]
                    }
                })}`} target="_blank">
                    {event}
                </Typography.Link>
                {index !== eventIds.length - 1 && ", "}
            </React.Fragment>
            })}</>
    }
    if(event.event === EVENTS_MAP.DELETE_CORRELATED_FINDING) {
        return <>Correlated finding removed: <Typography.Link href={`#/findings/${eventNewData}`} target="_blank">{eventNewData}</Typography.Link></>
    }
    if(event.event === EVENTS_MAP.RISK_REGISTER_UPDATE) {
        return <>Changed <Vocabulary name="exception" /> from {eventOldData} to {eventNewData}</>
    }
    if(event.event === EVENTS_MAP.UPDATE_CUSTOM_FIELDS){
        return <RenderCompareColumns title="Custom field updated" oldData={eventOldData} newData={eventNewData} editorContent />
    }
    if(event.event === EVENTS_MAP.ASSESSMENT_UPDATE) {
        return <>Changed <Vocabulary name="assessment" /> from {eventOldData} to {eventNewData}</>
    }
    if(event.event === EVENTS_MAP.ASSESSMENT_TAGS_UPDATED) {
        return <RenderArrayStringData title={`${getVocabulary("assessment")} tags updated from`} oldData={eventOldData} newData={eventNewData}/>
    }
    if(event.event === EVENTS_MAP.CVSS_MODIFIER_REMOVED) {
        return renderCVSSModifierHistory(eventOldData, eventNewData, "Removed CVSS Modifier");
    }
    if(event.event === EVENTS_MAP.CVSS_GROUP_MODIFIER_APPLIED) {
        return renderCVSSModifierHistory(eventOldData, eventNewData, <>Updated <Vocabulary name="product"/> level CVSS Modifier</>);
    }
    if(event.event === EVENTS_MAP.CVSS_SUBGROUP_MODIFIER_APPLIED) {
        return renderCVSSModifierHistory(eventOldData, eventNewData, <>Updated <Vocabulary name="subProduct"/> level CVSS Modifier</>);
    }
    if(event.event === EVENTS_MAP.CVSS_FINDING_MODIFIER_APPLIED) {
        return renderCVSSModifierHistory(eventOldData, eventNewData, "Updated Finding level CVSS Modifier");
    }
    if(event.event === EVENTS_MAP.CVSS_CVE_BASE_VECTOR_UPDATED) {
        return renderCVSSModifierHistory(eventOldData, eventNewData, "Updated CVSS CVE Base Vector");
    }
    if(event.event === EVENTS_MAP.SLA_RECALCULATION || event.event === EVENTS_MAP.SLA_RECOVERY){
        return parseHtml(event.note);
    }
}

const OtherPropertyDetailItem = (oldData, newData) => {
    return <Row align="middle">
        <Col span={11} className='p-t-0'>
        { Object.entries(oldData || []).map(([key,value])=> <Col key={key}><b>{key}</b> : <span title={value}>{renderPropertyValue(value)}</span></Col>)}
        </Col>
        <Col span={2} className='p-t-0 text-center'><RightArrowIcon /> </Col>
        <Col span={11} className='p-t-0'>
        { Object.entries(newData).map(([key,value])=> <Col key={key}><b>{key}</b> : <span title={value}>{renderPropertyValue(value)}</span></Col>)}
        </Col>
      </Row>
}

const renderPropertyValue = (propertyValue) =>{
    const value = CellRenderers.VALUE_OR_NA(propertyValue);
    return value.length > 30 ? value.substr(0, 30) + "..." : value;
}

const BasicDetailItem = ({data, showBusinessUnit}) => {
    if (!showBusinessUnit) {
        data.unshift(null)
    }
    const [businessUnit, product, subProduct, environment] = data;
    return <>
        {showBusinessUnit && <><b>Organization:</b> {businessUnit || 'N/A'}{' '}</>}
        <b><Vocabulary name='product'/></b>: {product || 'N/A'}{' '}
        <b><Vocabulary name='subProduct'/></b>: {subProduct || 'N/A'}{' '}
        <b>Environment:</b> <EnvironmentName name={environment}/>{' '}
    </>
}

function proposeCustomFieldsHistory(eventOldData, eventNewData) {
    const parseData = (eventData) => {
        return Object.fromEntries(
            eventData.split(',').map(field => {
              const match = field.match(/"([^"]+)"\s(.+)/);
              return match ? [match[1], match[2]] : [];
            })
          );
    };
  
    const oldData = parseData(eventOldData);
    const newData = parseData(eventNewData);
  
    return {
        newData: Object.entries(newData).map(([key, value]) => `${key}: ${value}`).join(' '),
        oldData: Object.entries(oldData).map(([key, value]) => `${key}: ${value}`).join('  ')
      };
}

const BasicDetailsUpdate = ({eventOldData, eventNewData, showBusinessUnit=false}) => {
    const oldDataArray = eventOldData.split(', ');
    const newDataArray = (eventNewData || '').split(', ');
    return <>Basic Information updated from{' '}
    <BasicDetailItem data={oldDataArray} showBusinessUnit={showBusinessUnit}/>
    {'to '}
    <BasicDetailItem data={newDataArray} showBusinessUnit={showBusinessUnit}/>
</>;
}

const RenderTagsUpdate = ({ data }) => {
    const { added = [], removed = [] } = data;

    return (
        <Text>
            <Text strong>Tags Updated</Text>
            
            {added.length > 0 && (
            <>
                <br />
                <Text strong>Added:</Text>{" "}
                {added.join(", ")}
            </>
            )}
            
            {removed.length > 0 && (
            <>
                <br />
                <Text strong>Removed:</Text>{" "}
                {removed.join(", ")}
            </>
            )}
        </Text>
    );
}

export function isComment({ event, field }) {
    // if event has any of these, means it is not a plain comment
    const fields = ['files','status','expiration']

    if(!_.isEmpty(event)){
       return _.values(EVENTS_MAP).indexOf(event) === -1;
    }
    if(!_.isEmpty(field)){
        return fields.indexOf(field) === -1
    }
    return true;
}

export function isHistory(event){
    return !isComment(event);
}

const RenderCompareColumns = ({oldData, newData, title, editorContent = false}) => {
    if (editorContent) {
        oldData = oldData !== null && oldData.includes(ATTACHMENT_LINK_PREFIX) ? oldData.replaceAll(ATTACHMENT_LINK_PREFIX, "") : oldData;
        newData = newData !== null && newData.includes(ATTACHMENT_LINK_PREFIX) ? newData.replaceAll(ATTACHMENT_LINK_PREFIX, "") : newData;
        oldData = CellRenderers.HTML_EDITOR(oldData);
        newData = CellRenderers.HTML_EDITOR(newData);
    }
    return (
        <Row gutter={BASE_GUTTER} align="middle">
            <Col span={24}>{title}</Col>
            <Col className='p-t-0' span={11}>{oldData}</Col>
            <Col className='p-t-0 text-center' span={2}> <RightArrowIcon />  </Col>
            <Col className='p-t-0' span={11}>{newData}</Col>
        </Row>
    )
}

const RenderArrayStringData = ({oldData='', newData='', title, cellType="VALUE_OR_NA"}) => {
    const _oldData = oldData?.split('[').pop().split(']').shift();
    const _newData = newData?.split('[').pop().split(']').shift();
    return <>{title} {CellRenderers[cellType](_oldData)} to {CellRenderers[cellType](_newData)}</>;
}

const renderDate = (eventData) => (eventData && moment(eventData).isValid()) ? moment(eventData).format('MM/DD/YYYY') : CellRenderers.VALUE_OR_NA();

export const getVocabularyDisplayText = (string, boldOnlyKeys = false) => {
    if(boldOnlyKeys){
        return string.split(/(\w+):/g).map((part, index) => 
            index % 2 === 1 ? <b key={index}>{part}:</b> : part
        );
    }
    const replacements = {
      Product: (
        <b>
          <Vocabulary name="product" />
        </b>
      ),
      "Sub-Product": (
        <b>
          <Vocabulary name="subProduct" />
        </b>
      ),
      Environment: <b>Environment</b>,
    };
    const mappedText = _.flatMap(string.split(" "), (word, index) => {
      const vocabularyWord = word.replace(/[:]/g, "");
      return [
        replacements[vocabularyWord] || word,
        word.includes(":") ? ":" : "",
        " ",
      ];
    });
  
    return <>{mappedText}</>;
};

export const renderCVSSModifierHistory = (eventOldData, eventNewData, eventText) => {
    const oldCVSSVector = JSON.parse(eventOldData).cvssVector
    const newCVSSVector = JSON.parse(eventNewData).cvssVector
    return <>{eventText}, CVSS Vector updated from <strong>{CellRenderers.VALUE_OR_NA(oldCVSSVector)}</strong> to <strong>{CellRenderers.VALUE_OR_NA(newCVSSVector)}</strong></>
}